import * as React from 'react';
import EmailFooterV2 from '../components/FooterV2';

interface SubscriptionItem {
  planName: string;
  planDescription: string;
  price: string;
  billingPeriod: string;
  nextBillingDate: string;
}

interface OrderConfirmationEmailProps {
  customerName?: string;
  items?: SubscriptionItem[];
  transactionId?: string;
  purchaseDate?: string;
  email?: string;
  total?: string;
}

export const OrderConfirmationEmail: React.FC<OrderConfirmationEmailProps> = ({
  customerName = "João Silva",
  items = [
    {
      planName: "Plano Profissional",
      planDescription: "Acesso completo a todas as funcionalidades premium",
      price: "R$ 99,95",
      billingPeriod: "Mensal",
      nextBillingDate: "14 Abr, 2025",
    },
    {
      planName: "Módulo Adicional - Analytics",
      planDescription: "Relatórios avançados e análise de dados",
      price: "R$ 49,95",
      billingPeriod: "Mensal",
      nextBillingDate: "14 Abr, 2025",
    },
  ],
  transactionId = "2342",
  purchaseDate = "14 Mar, 2025",
  email = "joao.silva@email.com",
  total = "R$ 149,90"
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Logo%20Trivium%20Rebranded%20Branco%20150%20dpi-0VfiiO2tOZNdZlvY5A7z3saYZGysgq.png"
          alt="Trivium Logo"
          width="140"
          style={{ display: 'block', margin: '0 auto' }}
        />
      </div>

      {/* Success Message */}
      <div style={successMessageStyle}>
        <div style={checkCircleOuterStyle}>
          <div style={checkCircleInnerStyle}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ color: 'white' }}>
              <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <h1 style={titleStyle}>Obrigado pela sua assinatura!</h1>
        <p style={subtitleStyle}>Seu pedido foi processado com sucesso.</p>

        <div style={orderBadgeStyle}>
          <span style={orderBadgeTextStyle}>Pedido #{transactionId}</span>
        </div>
      </div>

      {/* Order Details */}
      <div style={detailsContainerStyle}>
        <h2 style={sectionTitleStyle}>Detalhes da Assinatura</h2>

        {items.map((item, index) => (
          <div key={index} style={index < items.length - 1 ? itemStyle : { ...itemStyle, borderBottom: 'none' }}>
            <div style={itemContentStyle}>
              <div style={itemDetailsStyle}>
                <h3 style={itemTitleStyle}>{item.planName}</h3>
                <p style={itemDescriptionStyle}>{item.planDescription}</p>
                <p style={itemInfoStyle}>Período: {item.billingPeriod}</p>
                <p style={itemInfoStyle}>Próxima cobrança: {item.nextBillingDate}</p>
              </div>
              <div style={itemPriceStyle}>
                <span style={priceTextStyle}>{item.price}</span>
              </div>
            </div>
          </div>
        ))}

        {/* Total */}
        <div style={totalContainerStyle}>
          <span style={totalLabelStyle}>Total da Assinatura</span>
          <span style={totalValueStyle}>{total}</span>
        </div>

        {/* Account Information */}
        <div style={accountInfoContainerStyle}>
          <div style={accountDetailsStyle}>
            <h2 style={accountInfoTitleStyle}>Informações da Conta</h2>
            <p style={accountInfoTextStyle}>{customerName}</p>
            <p style={accountInfoTextStyle}>{email}</p>
          </div>
          <div style={dateContainerStyle}>
            <div style={dateTextStyle}>
              <span style={dateLabelStyle}>Data:</span> {purchaseDate}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <EmailFooterV2 variant="clean" showContactInfo={true} />
    </div>
  );
};

// Styles
const containerStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
  fontFamily: 'Arial, sans-serif',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
};

const headerStyle: React.CSSProperties = {
  backgroundColor: '#1F1746',
  padding: '24px',
  textAlign: 'center',
};

const successMessageStyle: React.CSSProperties = {
  backgroundColor: '#ffffff',
  padding: '40px 20px',
  textAlign: 'center',
};

const checkCircleOuterStyle: React.CSSProperties = {
  width: '96px',
  height: '96px',
  backgroundColor: '#E5F0FF',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 24px',
};

const checkCircleInnerStyle: React.CSSProperties = {
  width: '48px',
  height: '48px',
  backgroundColor: '#1F1746',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const titleStyle: React.CSSProperties = {
  margin: '0 0 8px',
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#333333',
};

const subtitleStyle: React.CSSProperties = {
  margin: '0 0 16px',
  fontSize: '16px',
  color: '#666666',
};

const orderBadgeStyle: React.CSSProperties = {
  display: 'inline-block',
  backgroundColor: '#FFD700',
  borderRadius: '999px',
  padding: '8px 16px',
};

const orderBadgeTextStyle: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold',
};

const detailsContainerStyle: React.CSSProperties = {
  padding: '0 24px 24px',
  backgroundColor: '#ffffff',
};

const sectionTitleStyle: React.CSSProperties = {
  fontSize: '16px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  borderBottom: '1px solid #1F1746',
  paddingBottom: '8px',
  marginTop: 0,
  marginBottom: '16px',
  color: '#1F1746',
};

const itemStyle: React.CSSProperties = {
  paddingBottom: '24px',
  marginBottom: '24px',
  borderBottom: '1px solid #eeeeee',
};

const itemContentStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
};

const itemDetailsStyle: React.CSSProperties = {
  flex: '1',
};

const itemTitleStyle: React.CSSProperties = {
  margin: '0 0 4px',
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#1F1746',
};

const itemDescriptionStyle: React.CSSProperties = {
  margin: '0 0 4px',
  fontSize: '12px',
  color: '#666666',
};

const itemInfoStyle: React.CSSProperties = {
  margin: '0 0 4px',
  fontSize: '12px',
  color: '#666666',
};

const itemPriceStyle: React.CSSProperties = {
  textAlign: 'right',
};

const priceTextStyle: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#1F1746',
};

const totalContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '16px',
};

const totalLabelStyle: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#1F1746',
};

const totalValueStyle: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#1F1746',
};

const accountInfoContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  borderTop: '1px solid #eeeeee',
  marginTop: '24px',
  paddingTop: '24px',
};

const accountDetailsStyle: React.CSSProperties = {
  flex: '1',
};

const accountInfoTitleStyle: React.CSSProperties = {
  margin: '0 0 4px',
  fontSize: '14px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  color: '#1F1746',
};

const accountInfoTextStyle: React.CSSProperties = {
  margin: '0 0 2px',
  fontSize: '12px',
  color: '#666666',
};

const dateContainerStyle: React.CSSProperties = {
  textAlign: 'right',
};

const dateTextStyle: React.CSSProperties = {
  fontSize: '12px',
  color: '#666666',
};

const dateLabelStyle: React.CSSProperties = {
  fontWeight: '600',
};

export default OrderConfirmationEmail; 